import { Button } from "@/components/ui/button";
import { Wrench } from 'lucide-react';
import { useRecordContext } from 'ra-core';
import { useNavigate } from 'react-router';
import type { Project } from '../types';

export const CreateProjectDesignRequestButton = () => {
    const record = useRecordContext<Project>();
    const navigate = useNavigate();

    if (!record) return null;

    const handleCreate = () => {
        navigate('/design_requests/create', {
            state: {
                record: {
                    project_id: record.id,
                    reference: `DR-${record.reference}`,
                    status: 'draft',
                    priority: 'medium',
                    description: `Design requirement for project: ${record.name}`
                }
            }
        });
    };

    return (
        <Button 
            variant="outline" 
            size="sm" 
            onClick={handleCreate}
            className="gap-2 text-orange-600 border-orange-200 hover:bg-orange-50"
        >
            <Wrench className="w-4 h-4" />
            Create Design Request
        </Button>
    );
};
